import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import {
  Table,
  Input,
  Card,
  Spin,
  Button,
  Modal,
  Form,
  message,
  Typography,
  Space,
  Select,
} from "antd";

import { useFetch } from "../../../Utils/useFetch";
import { FETCH_ALL_STOCK_API } from "../../../Constants/Apis";
import { updateProductType } from "../../../Services/StockService";

const { Search } = Input;
const { Title, Text } = Typography;
const { Option } = Select;

const initialState = {
  searchKeyword: "",
};

function reducer(state, action) {
  switch (action.type) {
    case "searchKeyword":
      return { ...state, searchKeyword: action.payload };
    default:
      return state;
  }
}

const ProductTypeValidationPage = ({ history, userData }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const {
    fetchedData: { data = [] },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_STOCK_API}/missing-pt`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  const handleFillProductType = (record) => {
    setSelectedRow(record);
    setModalVisible(true);
  };

  const handleModalOk = async () => {
    setSaving(true);
    try {
      const values = await form.validateFields();

      console.log({
        article: selectedRow.article,
        color: selectedRow.color,
        consignmentType: selectedRow.consignmentType,
        productType: values.productType,
      });

      await updateProductType({
        article: selectedRow.article,
        color: selectedRow.color,
        consignmentType: selectedRow.consignmentType,
        productType: values.productType,
      });

      message.success("Product Type updated successfully");
      callReFetch();
      setModalVisible(false);
      form.resetFields();
    } catch (err) {
      console.error("Error updating Product Type:", err);
      message.error("Failed to update Product Type");
    }
    setSaving(false);
  };

  const handleModalCancel = () => {
    form.resetFields();
    setModalVisible(false);
  };

  const filteredData = data.filter((item) =>
    item.article?.toLowerCase().includes(state.searchKeyword.toLowerCase())
  );

  const columns = [
    {
      title: "Article",
      dataIndex: "article",
      key: "article",
      sorter: (a, b) => a.article.localeCompare(b.article),
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Consignment Type",
      dataIndex: "consignmentType",
      key: "consignmentType",
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          onClick={() => handleFillProductType(record)}
        >
          Fill Product Type
        </Button>
      ),
    },
  ];

  const getProductTypeOptions = (type) => {
    if (type === "putus") {
      return ["PUTUS", "LIFESTYLE", "PUTUS OB"];
    } else if (type === "consignment") {
      return ["BASKET", "KONS NON PERF", "RUNNING"];
    }
    else{
      return ["BASKET", "KONS NON PERF", "RUNNING","PUTUS", "LIFESTYLE", "PUTUS OB"];

    }
    return [];
  };

  return (
    <Card
      title={<Title level={4}>Product Type Validation</Title>}
      bordered={false}
      style={{ margin: "0 auto", maxWidth: 900 }}
      bodyStyle={{ padding: 20 }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Search
          placeholder="Search Article"
          onSearch={handleSearch}
          onChange={(e) => handleSearch(e.target.value)}
          allowClear
          style={{ width: 300 }}
        />
        {loading ? (
          <Spin />
        ) : (
          <Table
            columns={columns}
            dataSource={filteredData.map((item, index) => ({
              ...item,
              key: `${item.article}-${item.color}-${item.consignmentType}-${index}`,
            }))}
            pagination={{ pageSize: 10 }}
            size="middle"
            bordered
            style={{ backgroundColor: "#fff", borderRadius: 8 }}
          />
        )}
      </Space>

      <Modal
        title={`Fill Product Type for "${selectedRow?.article}" - ${selectedRow?.color} (${selectedRow?.consignmentType})`}
        open={modalVisible}
        onOk={handleModalOk}
        confirmLoading={saving}
        onCancel={handleModalCancel}
        okText="Save"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Product Type"
            name="productType"
            rules={[
              { required: true, message: "Please select a product type" },
            ]}
          >
            <Select placeholder="Select product type">
              {getProductTypeOptions(selectedRow?.consignmentType || "").map(
                (option) => (
                  <Option key={option} value={option}>
                    {option}
                  </Option>
                )
              )}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

ProductTypeValidationPage.propTypes = {
  history: PropTypes.object,
  userData: PropTypes.object,
};

export default ProductTypeValidationPage;
